import { RouteObject } from 'react-router';

import { UserCreate } from './Create';
import { UserDetails } from './Details';
import { UserList } from './List';

export const USER_ROUTES: RouteObject[] = [
    {
        index: true,
        Component: UserList,
    },
    {
        path: 'create',
        Component: UserCreate,
    },
    {
        path: ':id',
        Component: UserDetails,
    },
];
